/**
 * 基础类，提供Class、Events、Attribute和Aspect支持
 *
 * @example
 *
 *      1、创建子类
 *          var Pig = Base.extend({
 *              attrs: {
 *                  name: ''
 *              },
 *              talk: function() {
 *                  alert(this.get('name'));
 *              }
 *          });
 *
 *     2、定义组件基类
 *          var Widget = Base.extend({
 *              initialize: function(config) {
 *                  Widget.superclass.initialize.call(this, config);
 *                  this.parseElement();
 *                  this.initProps();
 *                  this.delegateEvents();
 *                  this.setup();
 *              }
 *          })
 */
define(function(require, exports, module) {
    var Class = require('../class/class');
    var Events = require('../events/events');
    var Aspect = require('./aspect');
    var Attribute = require('./attribute');


    module.exports = Class.create({
        Implements: [Events, Aspect, Attribute],

        initialize: function(config) {
            this.initAttrs(config);

            // Automatically register `this._onChangeAttr` method as
            // a `change:attr` event handler.
            parseEventsFromInstance(this, this.attrs);
        },

        destroy: function() {
            this.off();

            for (var p in this) {
                if (this.hasOwnProperty(p)) {
                    delete this[p];
                }
            }

            // Destroy should be called only once, generate a fake destroy after called
            // https://github.com/aralejs/widget/issues/50
            this.destroy = function() {};
        }
    });

    function parseEventsFromInstance(host, attrs) {
        for (var attr in attrs) {
            if (attrs.hasOwnProperty(attr)) {
                var m = '_onChange' + ucfirst(attr);
                if (host[m]) {
                    host.on('change:' + attr, host[m]);
                }
            }
        }
    }

    function ucfirst(str) {
        return str.charAt(0).toUpperCase() + str.substring(1);
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/cui/core/base/base.js
 ** module id = 27
 ** module chunks = 13 14
 **/